// extracted by mini-css-extract-plugin
module.exports = {"emptyContent":"EmptyNodeList_emptyContent__PP-LQ","emptyNotesImg":"EmptyNodeList_emptyNotesImg__2mSsM"};